import { DataBean } from "../DataBean";

export class ActualValue extends DataBean {


    public async setActualValueForCodeFactory(year:any,factoryClass:any,actualConsecutive:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_setActualValueForCodeFactory_Number_String_Number_Number", [year,factoryClass,actualConsecutive,idEmployee]);
    }


}